
import { ThreeView, webcadDefines, ModelInfo } from '../../../view3d/webcad';
import * as THREE from 'three';
import { Loader, ObjectType } from './Loader';
import { OctreeManager } from '../Octree/OctreeManager';
import * as marietta from '../../../../marietta';
import { OBBManager } from '../OBBManager';

export interface pinData {
    id: string,
    guid: string,
    floor: number,
    text: string,
    transformMatrix: number[],
    x: number,
    y: number,
    z: number
}

export class CameraPinLoader {

    constructor() {}

    public load(url: string, pins: pinData[]) : Promise<void> {
        return new Loader(url).getLoader().loadAsync(url).then((glb) => {
            pins.forEach((pin) => {
                new AddCameraPin(glb.scene.clone()).set(pin);
            });
        });
    }
}

export class AddCameraPin {

    constructor(private object: THREE.Object3D) {}
    // アイテム登録
    protected regist(object: THREE.Object3D): void {
        ThreeView.get().wcItemmgr.furnitureObjects.push(<THREE.Group>(object));
        ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(object));
    }

    private creatModelInfo(object: THREE.Object3D, guid: string) {
        const model: ModelInfo = new ModelInfo();
        model.setTranslate(object.position.x, object.position.y, object.position.z);
        model.setRotation(0, 0, 0);
        model.setScale(1, 1, 1);
        model.setMatrix(object.matrixWorld);

        // model.reverse = false;

        model.type = 'pin';
        model.uuid = guid;

        model.typeExtras = webcadDefines.ExtrasType.CAMERA_PIN;
        model.subType = webcadDefines.ExtrasType.CAMERA_PIN;

        return model;
    }

    // private Transfomation(matrix: THREE.Matrix4) {
    //     // Matrix4からオイラー角に変換
    //     const euler = new THREE.Euler().setFromRotationMatrix(matrix);

    //     // ジオメトリに回転を適用
    //     this.object.rotateX(euler.x);
    //     this.object.rotateY(euler.y);
    //     this.object.rotateZ(euler.z);

    // }

    private registPinItem() {
        this.object.userData.obb = new OBBManager(this.object);
        ThreeView.get().wcItemmgr.addOtherShapes(this.object);
        ThreeView.get().wcItemmgr.addHouseData(this.object);
    }

    public set(pin: pinData) {

        const unit = ((v) => {
            return v / 1000;
        });

        const extras = ThreeView.get().wcItemmgr.GltfExtras;
        const center = marietta.webcad.WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);

        const mat = pin.transformMatrix;
        // const x = mat[12];
        const y = mat[13];
        // const z = mat[14];

        this.registPinItem();

        // CAMERA PINの位置決め
        const p1 = new THREE.Vector2(pin.x, pin.y);
        const p2 = new THREE.Vector2(center.x, center.y);
        const pos = p1.clone().sub(p2);

        const floorHeight = ThreeView.get().wcItemmgr.floorToHeight(pin.floor);
        const h = floorHeight + unit(y);
        const point3d = new THREE.Vector3(unit(pos.x), h, unit(pos.y));
        // this.object.position.set(point3d.x, point3d.y, point3d.z);
        // CAMERA PINの回転角設定
        const mat4 = new THREE.Matrix4();
        mat4.elements = [...mat];
        mat4.elements[12] = point3d.x;
        mat4.elements[13] = point3d.y;
        mat4.elements[14] = point3d.z;
        // this.Transfomation(mat4);
        this.object.applyMatrix4(mat4);
        console.log('before', this.object.matrix);
        this.object.updateMatrixWorld(true);
        //
        this.object.userData.pin_guid = pin.guid;
        this.object.userData.layer = `L${pin.floor}`;
        this.object.userData.modelInfo = this.creatModelInfo(this.object, pin.guid);

        // 画角内判定
        ThreeView.get().wcItemmgr.addHouseData(this.object);
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);

        this.regist(this.object);
    }
}